import React, { FC, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import ClTitle from 'components/clientComp/clTitle';
import { portfolioData } from 'configs/porfolioData';
import {
  ClAllProject,
  ClSitePreview,
} from 'components/clientComp/clPortfolio/components';

import './ClPortfolio.scss';

interface ISiteInfo {
  siteName: string;
  siteUrl: string;
}

const ClPortfolio: FC = () => {
  const siteInfoInitialState: ISiteInfo = {
    siteName: '',
    siteUrl: '',
  };
  const [showAllProject, setShowAllProject] = useState<boolean>(false);
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [siteInfo, setSiteInfo] = useState<ISiteInfo>(siteInfoInitialState);
  const onLoadMoreBtnClick = () => {
    setShowAllProject(true);
  };
  const onPreviewBtnClick = (siteName: string, siteUrl: string) => {
    setShowPreview(true);
    setSiteInfo({
      siteName: siteName,
      siteUrl: siteUrl,
    });
  };
  return (
    <Container fluid className="cl-portfolio">
      <ClTitle
        titleNumber={'03'}
        title={'Portfolio'}
        subTitle={'My Recent Work'}
      />
      <Row className="cl-portfolio-container">
        <div className="portfolio-items-container">
          {portfolioData.map(
            (val, index) =>
              index <= 2 && (
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                  key={index}
                  className="item"
                >
                  <div className="image-container">
                    <img
                      src={val.preview}
                      alt={val.siteName.replaceAll(' ', '-')}
                    />
                  </div>
                  <div className="portfolio-desc">
                    <h6 className="name">{val.siteName}</h6>
                    <p className="desc">{val.description}</p>
                  </div>
                  <div className="badge-container align-items-start">
                    {val.badge.map((item, itemKey) => (
                      <p className="badge-item" key={itemKey}>
                        {item}
                      </p>
                    ))}
                  </div>
                  <div className="button-container">
                    {val.githubUrl ? (
                      <a
                        href={val.githubUrl}
                        className="download-resume github"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Github
                      </a>
                    ) : (
                      <></>
                    )}
                    {'previewTarget' in val ? (
                      <a
                        href={val.siteUrl}
                        target={val.previewTarget}
                        className="download-resume preview"
                      >
                        Preview
                      </a>
                    ) : (
                      <button
                        onClick={() =>
                          onPreviewBtnClick(val.siteName, val.siteUrl)
                        }
                        className="download-resume preview"
                      >
                        Preview
                      </button>
                    )}
                  </div>
                </div>
              ),
          )}
        </div>
        <button onClick={onLoadMoreBtnClick} className="download-resume">
          Load more
        </button>
      </Row>
      <ClAllProject
        show={showAllProject}
        setShow={setShowAllProject}
        data={portfolioData}
        previewProjectBtnClick={onPreviewBtnClick}
      />
      <ClSitePreview
        show={showPreview}
        setShow={setShowPreview}
        siteName={siteInfo.siteName}
        siteUrl={siteInfo.siteUrl}
      />
    </Container>
  );
};

export default ClPortfolio;
